// pages/MenuPage.js

import React, { useEffect, useState } from "react";
import API from "../services/api";
import styles from "../styles/MenuPage.module.css";
import Header from "./Header";

export default function MenuPage() {

  const [menuData, setMenuData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* ---------------------------
     FETCH MENU
  ---------------------------- */

  useEffect(() => {

    const fetchMenu = async () => {

      try {

        const response = await API.get("/menu");

        setMenuData(response.data);

      } catch (err) {
        console.error("MENU FETCH ERROR:", err.response || err.message);
        setError(err.message || "Failed to load menu.");
      } finally {

        setLoading(false);

      }
    };

    fetchMenu();

  }, []);

  /* ---------------------------
     STATES
  ---------------------------- */

  if (loading) {
    return (
      <>
        <Header />
        <main className={styles.menuPage}>
          <div className={styles.hero}>
            <h2>Loading menu...</h2>
          </div>
        </main>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header />
        <main className={styles.menuPage}>
          <div className={styles.hero}>
            <h2>{error}</h2>
          </div>
        </main>
      </>
    );
  }

  // Helper function

  const trueUrl = (url) => {
  if (!url) return url;

  try {
    const u = new URL(url);

    u.pathname = u.pathname.replace(/^\/api/, '');

    return u.origin + u.pathname;
  } catch (e) {
    // fallback for relative URLs like "/api/uploads/menu"
    return url.replace(/^\/api/, '');
  }
};

  /* ---------------------------
     RENDER
  ---------------------------- */

  return (
    <>
      <Header />

      <main className={styles.menuPage}>

        {/* Hero */}

        <section className={styles.hero}>
          <span className={styles.subtitle}>
            seafood restaurant
          </span>

          <h1 className={styles.title}>
            {menuData.title}
          </h1>
        </section>

        {/* Categories */}

        <section className={styles.menuContainer}>

          {menuData.categories.map((category) => (

            <div
              key={category.id}
              id={category.id}
              className={styles.categorySection}
            >

              <h2 className={styles.categoryTitle}>
                {category.name}
              </h2>

              <div className={styles.itemsGrid}>

                {category.items.map((item) => (

                  <div
                    key={item.id}
                    className={styles.menuItem}
                  >

                    {/* Image */}

                    {item.image && (
                      <img
                        src={trueUrl(item.image)}
                        alt={item.name}
                        className={styles.itemImage}
                      />
                    )}

                    <div className={styles.itemContent}>

                      <div className={styles.itemHeader}>

                        <h3 className={styles.itemName}>
                          {item.name}
                        </h3>

                        <span className={styles.itemPrice}>
                          {item.price != null
                            ? `€${Number(item.price).toFixed(2)}`
                            : "Ask for price"}
                        </span>

                      </div>

                      {/* Description */}

                      {item.description && (
                        <p className={styles.itemDescription}>
                          {item.description}
                        </p>
                      )}

                      {/* Tags */}

                      {item.tags?.length > 0 && (
                        <div className={styles.tags}>
                          {item.tags.map((tag, index) => (
                            <span
                              key={index}
                              className={styles.tag}
                            >
                              {tag}
                            </span>
                          ))}
                        </div>
                      )}

                    </div>

                  </div>

                ))}

              </div>

            </div>

          ))}

        </section>

      </main>
    </>
  );
}